import { CALENDAR_SELECTIONS_SESSION_STORAGE_KEY } from '../storeCalendarSelections/storeCalendarSelections';
import { getServiceSlug } from '../../getServiceSlug/getServiceSlug';
import { CALENDAR_PAGE_URL_PATH_PARAM } from '../../const';
import { ReservedSlugs } from '../../urlUtils/urlUtils';
export const extractCalendarSelections = async _ref => {
  let {
    session,
    wixCodeApi
  } = _ref;
  const serviceSlug = await getServiceSlug({
    wixCodeApi,
    isAppReflowServiceSlug: true,
    pageName: CALENDAR_PAGE_URL_PATH_PARAM
  });
  if (serviceSlug !== ReservedSlugs.CALENDAR_COMPLEX_NAVIGATION) {
    return;
  }
  const calendarSelections = session.getItem(CALENDAR_SELECTIONS_SESSION_STORAGE_KEY);
  if (!calendarSelections) {
    return;
  }
  return JSON.parse(calendarSelections);
};
//# sourceMappingURL=extractCalendarSelections.js.map